import { Modal } from 'components/Modal';
import styles from './CreateEmployedsСategory.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { useEffect, useState } from 'react';
import { Drawer, FocusTrap, Loader, Textarea } from '@mantine/core';
import { Label } from 'components/CreateOrderForm';
import {
  useCreateCategoryEmployedsMutation,
  useUpdateCategoryEmployedsMutation,
} from 'redux/Api/employedsApi/employedsApi';
import filterStyles from '../EmployedsFiltersMobile/EmployedsMobileFilterDrawer.module.scss';

type CreateEmployedsCategoryProps = {
  setIsShowFinishModal: (e: boolean) => void;
  setShowCopiedSuccess: (e: boolean) => void;
  variant?: 'modal' | 'drawer';
  initialData?: { id: string; name: string } | null;
  setInitialData?: (e: { id: string; name: string } | null) => void;
  textSuccess?: (e: string) => void;
  onCategoryCreated?: () => void;
};

export const CreateEmployedsСategory = ({
  setIsShowFinishModal,
  setShowCopiedSuccess,
  variant = 'modal',
  initialData,
  setInitialData,
  textSuccess,
  onCategoryCreated,
}: CreateEmployedsCategoryProps) => {
  const [value, setValue] = useState(initialData ? initialData.name : '');
  const [textError, setTextError] = useState('');

  useEffect(() => {
    if (value.length > 50) {
      setTextError('Максимальная длина категории 50 символов');
    } else {
      setTextError('');
    }
  }, [value]);

  const [createCategory, { isLoading }] = useCreateCategoryEmployedsMutation();
  const [updateCategory, { isLoading: isUpdating }] =
    useUpdateCategoryEmployedsMutation();

  const handleClose = () => {
    setIsShowFinishModal(false);
    if (setInitialData) setInitialData(null);
  };

  const handleUpdateCategory = async () => {
    if (value.trim().length === 0) {
      setTextError('Поле имя обязательно.');
      return;
    }
    if (value.length > 50) return;
    setTextError('');
    try {
      await updateCategory({ id: String(initialData?.id), name: value }).unwrap();
      setShowCopiedSuccess(true);
      if (textSuccess) textSuccess('Категория успешно обновлена');
      setIsShowFinishModal(false);
      if (setInitialData) setInitialData(null);
    } catch (error: any) {
      const errorMessage = error.data?.message || 'Произошла ошибка';
      setTextError(errorMessage);
    }
  };

  const handleCreateCategory = async () => {
    if (value.trim().length === 0) {
      setTextError('Поле имя обязательно.');
      return;
    }
    if (value.length > 50) return;
    setTextError('');
    try {
      await createCategory({ name: value }).unwrap();
      onCategoryCreated?.();
      setShowCopiedSuccess(true);
      setIsShowFinishModal(false);
      if (setInitialData) setInitialData(null);
    } catch (error: any) {
      const errorMessage = error.data?.message || 'Произошла ошибка';
      setTextError(errorMessage);
    }
  };

  const formFields = (
    <>
      {variant === 'modal' && (
        <Title title={initialData ? 'Редактировать категорию' : 'Новая категория'} />
      )}
      <div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div>
            <Label text='Название' />
            <Textarea
              placeholder='Введи название'
              required
              autosize
              minRows={1}
              maxRows={4}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              styles={{
                input: {
                  display: 'flex',
                  alignItems: 'center',
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  fontSize: '16px',
                  border: textError ? '1px solid red' : 'none',
                },
              }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '4px' }}>
            {textError ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  color: 'red',
                  fontSize: '14px',
                }}>
                {textError}
              </div>
            ) : (
              <div></div>
            )}
            <p
              style={{
                display: 'flex',
                alignItems: 'start',
                color: textError ? 'red' : '#71869D',
                paddingTop: '4px',
              }}>
              {value.length}/50
            </p>
          </div>
        </div>
      </div>

      <div className={styles.btn}>
        <Button
          onClick={handleClose}
          theme='outline'
          className={styles.btn_cancel}
          size='L'>
          <IconCancel />
        </Button>
        <Button
          onClick={initialData ? handleUpdateCategory : handleCreateCategory}
          disabled={isLoading}
          className={styles.btn_exit}
          theme='filed'
          size='L'>
          <div>
            {initialData ? 'Сохранить изменения' : 'Создать'}
            {isLoading || isUpdating ? <Loader size='xs' color='white' /> : <IconDone />}
          </div>
        </Button>
      </div>
    </>
  );

  if (variant === 'drawer') {
    return (
      <Drawer
        opened
        onClose={handleClose}
        position='bottom'
        zIndex={1001}
        withCloseButton={false}
        styles={{
          content: {
            height: 'fit-content',
            maxHeight: '90vh',
            borderRadius: '13px 13px 0px 0px',
            backgroundColor: '#FFF',
            padding: '16px 16px 4px 16px',
            boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
            display: 'flex',
            flexDirection: 'column',
          },
          body: {
            padding: '0',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            overflow: 'hidden',
          },
        }}>
        <FocusTrap.InitialFocus />
        <div className={filterStyles.header}>
          <span className={filterStyles.headerTitle}>
            {initialData ? 'Редактировать категорию' : 'Новая категория'}
          </span>
          <span className={filterStyles.headerClear} onClick={handleClose}>
            Готово
          </span>
        </div>
        <div className={styles.drawerBody}>{formFields}</div>
      </Drawer>
    );
  }

  return (
    <Modal setOpen={setIsShowFinishModal}>
      <div className={styles.root}>{formFields}</div>
    </Modal>
  );
};
